module.exports = __webpack_public_path__ + "img/sunflower.1bfd5dc5.svg";